import React, { createContext, type ReactNode, useContext } from 'react';

export const NestedPlaceholderContext = createContext<boolean>(false);

interface Props {
	children: ReactNode;
}

export function NestedPlaceholderContextProvider({ children }: Props) {
	return (
		// Explicit for clarity in this case.
		// eslint-disable-next-line react/jsx-boolean-value
		<NestedPlaceholderContext.Provider value={true}>
			{children}
		</NestedPlaceholderContext.Provider>
	);
}
NestedPlaceholderContextProvider.displayName =
	'NestedPlaceholderContextProvider';

export function useIsInNestedPlaceholder() {
	return useContext(NestedPlaceholderContext);
}
